import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';

const WelcomePopup = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user) return;
    const key = `welcome_seen_${user.id}`;
    const seen = localStorage.getItem(key);
    if (!seen) {
      setVisible(true);
    }
  }, [user]);

  const handleClose = () => {
    const key = `welcome_seen_${user.id}`;
    localStorage.setItem(key, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  // Uniquement pour les commerciaux
  if (!['commercial', 'manager_vente', 'employe_vente'].includes(user?.role)) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '2rem 1rem'
    }}>
      <div style={{
        background: 'white', borderRadius: '16px',
        border: '0.5px solid #e5e7eb',
        padding: '2rem 2rem 1.5rem',
        maxWidth: '460px', width: '100%'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ fontSize: '48px', marginBottom: '0.75rem' }}>🎉</div>
          <p style={{ fontSize: '22px', fontWeight: '500', margin: '0 0 6px', color: '#111' }}>
            Bienvenue {user?.prenom} !
          </p>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
            Bienvenue dans ton espace personnel Eco'enr
          </p>
        </div>

        <div style={{ border: '0.5px solid #e5e7eb', borderRadius: '8px', padding: '14px 16px', marginBottom: '1.25rem' }}>
          <p style={{ fontSize: '13px', fontWeight: '500', color: '#111', margin: '0 0 8px' }}>🛠️ À quoi sert ce CRM ?</p>
          <p style={{ fontSize: '13px', color: '#6b7280', margin: '0 0 10px' }}>Cet outil est ton espace de travail au quotidien. Il te permet de :</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {[
              'Gérer et suivre tous tes prospects en un seul endroit',
              'Convertir tes prospects en clients installés',
              "Suivre l'avancement de chaque dossier en temps réel"
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#1fd1fd', fontSize: '16px' }}>→</span>
                <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ borderTop: '0.5px solid #e5e7eb', paddingTop: '1.25rem', marginBottom: '1.25rem' }}>
          <p style={{ fontSize: '13px', fontWeight: '500', color: '#6b7280', margin: '0 0 0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Pour bien démarrer</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {[
              { emoji: '📋', titre: 'Tes prospects t\'attendent', texte: 'Retrouve tes prospects dans l\'onglet "Prospects entrants".' },
              { emoji: '⚡', titre: 'Contacte tes prospects le plus vite possible', texte: 'Plus tu contactes un prospect rapidement après sa demande, plus tu as de chances de le convertir en client. Chaque minute compte !' },
              { emoji: '📞', titre: 'Mets à jour les statuts', texte: 'Après chaque appel, change le statut du prospect pour garder le suivi à jour.' },
              { emoji: '📝', titre: 'Note chaque échange', texte: 'Ajoute des notes directement depuis la fiche du prospect ou via le bouton "+" en bout de ligne — un bon suivi fait toute la différence.' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <span style={{ fontSize: '20px', lineHeight: '1.4' }}>{item.emoji}</span>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '500', color: '#111', margin: '0 0 2px' }}>{item.titre}</p>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>{item.texte}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '12px 14px', marginBottom: '1.25rem', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{ fontSize: '16px', lineHeight: '1.5' }}>💡</span>
          <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Tu recevras ce type de pop-up à chaque nouveauté sur le CRM — reste attentif, elles contiennent des guides pour tirer le meilleur de l'outil !</p>
        </div>

        <button
          onClick={handleClose}
          style={{
            width: '100%', padding: '10px',
            fontSize: '14px', fontWeight: '500',
            background: '#1fd1fd', color: '#04334a',
            border: 'none', borderRadius: '8px', cursor: 'pointer'
          }}
        >
          C'est parti ! 🚀
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;
